var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafariIconicLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12C21.5 16.9705 17.4705 21 12.5 21C7.52943 21 3.5 16.9705 3.5 12C3.5 7.02944 7.52943 3 12.5 3C17.4705 3 21.5 7.02944 21.5 12Z",
    stroke: "#841474",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5011 3.51562L15.051 4.78837M9.49902 20.4854L9.94918 19.2127",
    stroke: "#841474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9845 15.0021L19.7117 14.552M4.01465 9L5.28738 9.45016",
    stroke: "#841474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6215 8.12109L19.4033 8.70274M4.37793 15.8764L5.5962 15.2948",
    stroke: "#841474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3774 20.1225L15.7958 18.9042M8.62207 3.87891L9.20372 5.09718",
    stroke: "#841474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 10.0117L14.4889 13.9899",
    stroke: "#841474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7404 13.5849L16.4881 8.34157C16.5192 8.24832 16.4949 8.14552 16.4254 8.07602C16.3559 8.00651 16.2531 7.98224 16.1598 8.01332L10.9166 9.76107C10.6066 9.86438 10.3634 10.1076 10.2601 10.4176L8.51234 15.6609C8.48127 15.7541 8.50554 15.8569 8.57504 15.9264C8.64454 15.9959 8.74734 16.0202 8.84059 15.9891L14.0839 14.2414C14.3938 14.1381 14.6371 13.8948 14.7404 13.5849Z",
    stroke: "#841474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariIconicLogo);
export default __webpack_public_path__ + "static/media/safari-iconic-logo.e2e22378.svg";
export { ForwardRef as ReactComponent };